import { Group, ImageField, NodeField, PlainNodeField, SaveBar, getPath } from "@/admin/fields";

const GlobalTab = ({ content, update, saving, dirty, message, onSave }) => {
  return (
    <div data-testid="admin-tab-content-global">
      <SaveBar tabId="global" saving={saving} dirty={dirty} message={message} onSave={onSave} />
      <Group title="Brand & Logo" open>
        <ImageField
          label="Logo image"
          value={getPath(content, ["global", "logoImage"])}
          onChange={(value) => update(["global", "logoImage"], value)}
          defaultNote="Using the default logo mark"
          testId="admin-logo-field"
        />
        <NodeField content={content} update={update} label="Brand subtitle (next to logo)" path={["global", "brandSub"]} />
      </Group>

      <Group title="Navigation Labels">
        <div className="af-grid-2">
          <NodeField content={content} update={update} label="Home" path={["global", "nav", "home"]} />
          <NodeField content={content} update={update} label="Services" path={["global", "nav", "services"]} />
          <NodeField content={content} update={update} label="Blog" path={["global", "nav", "blog"]} />
          <NodeField content={content} update={update} label="About Us" path={["global", "nav", "about"]} />
          <NodeField content={content} update={update} label="Contact" path={["global", "nav", "contact"]} />
        </div>
      </Group>

      <Group title="Booking CTA">
        <NodeField content={content} update={update} label="CTA button text (all booking buttons)" path={["global", "ctaLabel"]} />
        <NodeField content={content} update={update} label="Alternative contact link text" path={["global", "altContactLabel"]} />
        <PlainNodeField content={content} update={update}
          label="Calendly scheduling link"
          path={["global", "calendlyUrl"]}
          placeholder="https://calendly.com/your-account/discovery-call"
        />
      </Group>

      <Group title="Contact Bar">
        <NodeField content={content} update={update} label="Title" path={["global", "contactBar", "title"]} multiline />
        <NodeField content={content} update={update} label="Text" path={["global", "contactBar", "text"]} multiline />
        <NodeField content={content} update={update} label="Get in touch label" path={["global", "contactBar", "ctaLabel"]} />
        <div className="af-grid-2">
          <PlainNodeField content={content} update={update} label="Business email" path={["global", "contactBar", "email"]} />
          <PlainNodeField content={content} update={update} label="Business phone" path={["global", "contactBar", "phone"]} />
        </div>
      </Group>

      <Group title="Social Links">
        <p className="af-hint-block">
          Leave a field blank to hide that icon on the site.
        </p>
        <div className="af-grid-2">
          <PlainNodeField content={content} update={update} label="LinkedIn URL" path={["global", "socials", "linkedin"]} />
          <PlainNodeField content={content} update={update} label="YouTube URL" path={["global", "socials", "youtube"]} />
        </div>
      </Group>

      <Group title="Footer">
        <NodeField content={content} update={update} label="Copyright text" path={["global", "footer", "copyright"]} />
        <div className="af-grid-2">
          <NodeField content={content} update={update} label="Privacy link label" path={["global", "footer", "privacyLabel"]} />
          <NodeField content={content} update={update} label="Terms link label" path={["global", "footer", "termsLabel"]} />
          <NodeField content={content} update={update} label="Cookie link label" path={["global", "footer", "cookiesLabel"]} />
        </div>
      </Group>

      <Group title="Quick Inquiry Form (Footer, all pages)">
        <NodeField content={content} update={update} label="Title" path={["global", "quickInquiry", "title"]} />
        <NodeField content={content} update={update} label="Text" path={["global", "quickInquiry", "text"]} multiline />
        <div className="af-grid-2">
          <NodeField content={content} update={update} label="Name placeholder" path={["global", "quickInquiry", "namePlaceholder"]} />
          <NodeField content={content} update={update} label="Email placeholder" path={["global", "quickInquiry", "emailPlaceholder"]} />
        </div>
        <div className="af-grid-2">
          <NodeField content={content} update={update} label="Message placeholder" path={["global", "quickInquiry", "messagePlaceholder"]} />
          <NodeField content={content} update={update} label="Submit button label" path={["global", "quickInquiry", "submitLabel"]} />
        </div>
      </Group>

      <Group title="Cookie Banner">
        <NodeField content={content} update={update} label="Banner text" path={["global", "cookieBanner", "text"]} multiline />
        <div className="af-grid-2">
          <NodeField content={content} update={update} label="Accept button" path={["global", "cookieBanner", "acceptLabel"]} />
          <NodeField content={content} update={update} label="Decline button" path={["global", "cookieBanner", "declineLabel"]} />
        </div>
      </Group>

      <Group title="Full Contact Form (Services, About, Blog & Contact pages)">
        <p className="af-hint-block">
          This form appears at the bottom of the Services, About, Blog, Blog Post, Service Detail and Contact
          pages. It is not shown on the Home page.
        </p>
        <div className="af-grid-2">
          <NodeField content={content} update={update} label="Title line 1" path={["global", "contactForm", "title1"]} />
          <NodeField content={content} update={update} label="Title line 2" path={["global", "contactForm", "title2"]} />
        </div>
        <NodeField content={content} update={update} label="Title accent (green)" path={["global", "contactForm", "accent"]} />
        <NodeField content={content} update={update} label="Paragraph" path={["global", "contactForm", "paragraph"]} multiline />
        {getPath(content, ["global", "contactForm", "points"]).map((point, index) => (
          <NodeField content={content} update={update} key={index} label={`Reassurance point ${index + 1}`} path={["global", "contactForm", "points", index]} />
        ))}
        <NodeField content={content} update={update} label="Submit button label" path={["global", "contactForm", "submitLabel"]} />
      </Group>
    </div>
  );
};

export default GlobalTab;
